import VNode from './vnode'

const createElementNode = document.createElement.bind(document)
const createTextNode = document.createTextNode.bind(document)

interface VNodeProps {
  class: object
  on: object
  style: object
}

interface Patch {
  tag: string
  props: VNodeProps
  children: any
}

export default function createElement ({ tag, props, children }: Patch, ctx: any) {
  const { class: classProps, on: eventsProps, style: styleProps } = props
  const className = tag.replace(/(^[^.]+)|(#.+)/g, '').slice(1).replace(/\./g, ' ')
  const el = createElementNode(tag.replace(/(\.|#).+/g, ''))
  if (className) el.className = className
  for (let className in classProps) {
    if (classProps[className]) el.classList.add(className)
  }
  for (let style in styleProps) el.style[style] = styleProps[style]
  for (let event in eventsProps) el.addEventListener(event, (e: MouseEvent) => eventsProps[event].call(ctx, e))
  children.forEach((child: Patch) => {
    const node = child instanceof VNode ? createElement(child, ctx) : createTextNode(child)
    el.appendChild(node)
  })
  return el
}

export function createCommentNode () {
  return document.createComment('')
}
